export const headers = [
    { value: "Comandas" },
    { value: "Productos" },
    {
        value: "Precio",
    },
    {
        value: "Cantidad",
    },
    {
        value: "IVA",
    },
    {
        value: "Total",
    },
]